import "./styles/index.scss";
import domReady from "@wordpress/dom-ready";
import { createRoot } from "react-dom/client";

// The below comment is critical to the scripts/generate-appp.js to work.
// Apps
import LatestPosts from "./Apps/LatestPosts";
import NotFound from "./Apps/NotFound";

const apps = {
  NotFound,
  LatestPosts,
};

domReady(() => {
  if (
    window.rafa_react_components &&
    window.rafa_react_components.shortcode_atts.length > 0
  ) {
    // Loop through and create apps.
    for (
      let i = 0;
      i < window.rafa_react_components.shortcode_atts.length;
      i++
    ) {
      const shortcode_atts = window.rafa_react_components.shortcode_atts[i];
      const container_id = shortcode_atts.container_id;
      const App = apps[shortcode_atts.app] || NotFound;
      const rootApp = createRoot(document.getElementById(container_id));
      rootApp.render(
        <React.StrictMode>
          <App {...shortcode_atts} />
        </React.StrictMode>
      );
    }
  }
});
